



























































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import {
  loadReservationDataAction,
  submitReservationAction,
  removePayFailReservationAction
} from "@/store/reservation/action-types";
import {
  updateFormData,
  updateFormResult,
  resetReservationState
} from "@/store/reservation/mutation-types";
import { reservationDisabledHours } from "@/helper/reservationHelper";
import { weChatPay } from "@/helper/weChatHelper";
import PriceView from "@/shared/priceView.vue";
import ReservationReviewInfoView from "@/shared/reservationReviewInfoView.vue";
import { launchMiniapp } from "@/store/user/mutation-types";
import { resetHomeState } from "@/store/home/mutation-types";
import { timeRangeList } from "@/helper/reservationHelper";

const HomeModule = namespace("home");
const ReservarionModule = namespace("reservation");
const UserModule = namespace("user");

@Component({
  components: {
    PriceView,
    ReservationReviewInfoView
  }
})
export default class Reservation extends Vue {
  @Prop() private courseId!: string;
  @Prop() private courseType!: string;
  @Prop() private paied!: boolean;

  @ReservarionModule.State("courseInfo") courseInfo: any;
  @ReservarionModule.State("formData") formData: any;
  @ReservarionModule.State("formResults") formResults: any;
  @ReservarionModule.State("reservationPending") reservationPending: any;

  @UserModule.State("stn") studentName: any;
  @UserModule.State("pho") phone: any;

  @HomeModule.Mutation(resetHomeState) resetHomeState: any;

  @ReservarionModule.Action(loadReservationDataAction)
  loadReservationDataAction: any;

  @ReservarionModule.Action(submitReservationAction)
  submitReservationAction: any;

  @ReservarionModule.Action(removePayFailReservationAction)
  removePayFailReservation: any;

  @ReservarionModule.Mutation(updateFormData) updateFormData: any;
  @ReservarionModule.Mutation(updateFormResult) updateFormResult: any;
  @ReservarionModule.Mutation(resetReservationState) resetReservationState: any;

  @UserModule.Mutation(launchMiniapp) launchMiniapp: any;

  showReview = false;
  showLoading = false;

  private formRendered = false;

  created() {
    console.log("Reservation created:", this.courseId, this.courseType);
    if (this.courseId) {
      this.loadReservationDataAction({
        id: this.courseId,
        type: this.courseType
      }).catch((error: any) => {
        console.log(error);
        this.$router.replace({ name: "home" });
      });
    } else {
      this.$router.replace({ name: "home" });
    }
  }

  get timeRange() {
    return timeRangeList(9, 21, 15, 15);
  }

  get form() {
    this.formRendered = true;
    return this.$form.createForm(this, {
      onValuesChange: (_, values) => {
        this.updateFormData(values);
        if (values.firstDate) {
          this.form.resetFields(["firstDateTime"]);
        }
      },
      mapPropsToFields: () => {
        return {
          name: this.$form.createFormField({
            value: this.studentName
          }),
          phoneNumber: this.$form.createFormField({
            value: this.phone
          }),
          firstDate: this.$form.createFormField({
            value: this.formData.firstDate.value
          }),
          firstDateTime: this.$form.createFormField({})
        };
      }
    });
  }

  handleSubmit(e: any) {
    e.preventDefault();
    const elem = this.$el;
    const formElement = this.$refs.form as any;
    elem.scrollTop = formElement.offsetTop + formElement.clientHeight;
    this.form.validateFields((err, values) => {
      if (!err) {
        this.updateFormResult(values);
        this.showReview = true;
      }
    });
  }
  cancelReview() {
    this.showReview = false;
  }

  confirmReview() {
    this.showLoading = true;
    this.submitReservationAction()
      .then(() => {
        this.showLoading = false;
        if (this.reservationPending && this.reservationPending.reservation) {
          const reservation = this.reservationPending.reservation;
          if (reservation.payStatus === "pending") {
            const prepayPackage = this.reservationPending.prepayPackage;
            return weChatPay(prepayPackage);
          } else {
            return Promise.resolve();
          }
        }
        return Promise.reject();
      })
      .then(() => this.reservationDone())
      .catch(() => {
        this.removePayFailReservation();
      });
  }

  disabledHours() {
    return reservationDisabledHours;
  }

  beforeDestroy() {
    this.resetReservationState();
  }

  private reservationDone() {
    this.resetHomeState();
    this.$router.replace({ name: "home" });
    this.launchMiniapp(false);
  }
}
